<div class="modal-header">
  <h5 class="rd-title">Requirement Details</h5>
  <button
    type="button"
    class="accello-icon-btn"
    aria-label="Close"
    (mousedown)="isCloseActive = true"
    (mouseup)="isCloseActive = false"
    (mouseleave)="isCloseActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="close"
      [src]="
        isCloseActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>

<div class="modal-body">

 <div class="border-div d-flex">
   <!-- Left sidebar navigation -->
   <div class="rd-sidebar">
    <button
      *ngFor="let item of navItems"
      type="button"
      class="rd-nav-item"
      [class.rd-nav-item--active]="activeSection === item.sectionId"
      (click)="scrollTo(item.sectionId)"
    >
      {{ item.label }}
    </button>
  </div>

  <!-- Right scrollable content -->
  <div class="rd-content">

    <!-- ── Section 1: Name, ID & Path ──────────────────────────────────── -->
    <div class="rd-section" id="section-name">
      <h6 class="rd-section-title">Name, ID &amp; Path</h6>
      <div class="rd-key-value-table">
        <div class="rd-kv-row">
          <div class="rd-kv-label">Name</div>
          <div class="rd-kv-value">{{ data?.nameInfo?.name }}</div>
        </div>
        <div class="rd-kv-row">
          <div class="rd-kv-label">ID</div>
          <div class="rd-kv-value">{{ data?.nameInfo?.id }}</div>
        </div>
        <div class="rd-kv-row rd-kv-row--last">
          <div class="rd-kv-label">Path</div>
          <div class="rd-kv-value">{{ data?.nameInfo?.path }}</div>
        </div>
      </div>
    </div>

    <!-- ── Section 2: Requirements ─────────────────────────────────────── -->
    <div class="rd-section" id="section-requirements">
      <h6 class="rd-section-title">Requirements</h6>
      <table class="rd-table">
        <thead>
          <tr>
            <th class="rd-th rd-th--fixed-300">Requirement ID</th>
            <th class="rd-th">Requirement Title</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let req of data?.requirements; let odd = odd"
            [class.rd-tr--odd]="odd"
          >
            <td class="rd-td rd-td--fixed-300">{{ req.requirementId }}</td>
            <td class="rd-td">{{ req.requirementTitle }}</td>
          </tr>
          <tr *ngIf="!data?.requirements?.length">
            <td class="rd-td rd-td--empty" colspan="2">No requirements available.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Section 3: Validation ───────────────────────────────────────── -->
    <div class="rd-section" id="section-validation">
      <h6 class="rd-section-title">Validation</h6>
      <ul class="rd-bullet-list">
        <li *ngFor="let item of data?.validation">{{ item }}</li>
        <li *ngIf="!data?.validation?.length" class="rd-bullet-list__empty">
          No validation criteria available.
        </li>
      </ul>
    </div>

    <!-- ── Section 4: UI Behavior ──────────────────────────────────────── -->
    <div class="rd-section" id="section-ui-behavior">
      <h6 class="rd-section-title">UI Behavior</h6>
      <ul class="rd-bullet-list">
        <li *ngFor="let item of data?.uiBehavior">{{ item }}</li>
        <li *ngIf="!data?.uiBehavior?.length" class="rd-bullet-list__empty">
          No UI behavior criteria available.
        </li>
      </ul>
    </div>

    <!-- ── Section 5: Error Conditions ────────────────────────────────── -->
    <div class="rd-section" id="section-error-conditions">
      <h6 class="rd-section-title">Error Conditions</h6>
      <table class="rd-table">
        <thead>
          <tr>
            <th class="rd-th">Conditions</th>
            <th class="rd-th">Expected Result</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let ec of data?.errorConditions; let odd = odd"
            [class.rd-tr--odd]="odd"
          >
            <td class="rd-td">{{ ec.condition }}</td>
            <td class="rd-td">{{ ec.expectedResult }}</td>
          </tr>
          <tr *ngIf="!data?.errorConditions?.length">
            <td class="rd-td rd-td--empty" colspan="2">No error conditions available.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Section 6: Dependencies ─────────────────────────────────────── -->
    <div class="rd-section" id="section-dependencies">
      <h6 class="rd-section-title">Dependencies</h6>
      <table class="rd-table">
        <thead>
          <tr>
            <th class="rd-th">Section</th>
            <th class="rd-th">Dependency</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let dep of data?.dependencies; let odd = odd"
            [class.rd-tr--odd]="odd"
          >
            <td class="rd-td">{{ dep.section }}</td>
            <td class="rd-td">{{ dep.dependency }}</td>
          </tr>
          <tr *ngIf="!data?.dependencies?.length">
            <td class="rd-td rd-td--empty" colspan="2">No dependencies available.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Section 7: Heading Path ─────────────────────────────────────── -->
    <div class="rd-section" id="section-heading-path">
      <h6 class="rd-section-title">Heading Path</h6>
      <ul class="rd-bullet-list">
        <li *ngFor="let item of data?.headingPath">{{ item }}</li>
        <li *ngIf="!data?.headingPath?.length" class="rd-bullet-list__empty">
          No heading path available.
        </li>
      </ul>
    </div>

  </div><!-- /rd-content -->
 </div>
</div>

<div class="modal-footer">
  <button class="rd-close-btn" (click)="close()">Close</button>
</div>
